import OrphanExchangesGrid from "./OrphanExchangesGrid.js";

/**
 * Renders the "Orphan Exchanges" page
 * @returns {JSX.Element}
 * @constructor
 */
const OrphanExchangesPage = () => {
    return (
        <div>
            <OrphanExchangesGrid />
        </div>
    );
}

export default OrphanExchangesPage;
